export const formatDateTime = (dateValue: string | Date | null): string => {
  if (!dateValue) return "";

  const date = new Date(dateValue);

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
